<template>
  <main>
    
      
    <div class="container impression-list">
      <p class="hero-description">
          {{heroContent}}
        </p>
    <h3 class="hero-description" style="text-align:center;">
          <a href="#"   @click="goToSignup()">{{$t('feed.Signup')}}</a> {{signupText}}
        </h3>
        <LoadingSpinner :loading='loading' v-if='loading'/>
        <div v-show="!loading">
        <template v-for="(activity, index) in feed" :key="activity.id" >
            <InFeedAdsense
                root-class="adswrapper card activity-card-container"
                ins-class="googadd"
                data-ad-layout-key="-8y-2t-2k-gn+1t9"
                data-ad-client="ca-pub-3164999027063451"
                data-ad-slot="2207627566"
                v-if="index > 0 && index%getRandomModulus(2, 4) == 0 && !isFinTriviaSite()">
            </InFeedAdsense>
            <ActivityCard :activity="activity" @on-view-details="viewDetails" @on-account-needed="openAccountNeededModal"></ActivityCard>
        </template>
      </div>
    </div>

    <PostDetailsDialog ref="detailsDialog" :post="selectedPost" ></PostDetailsDialog>
    <AccountNeededModal ref='accountNeededModal' @to-login="goToLogin" @to-signup="goToSignup" />
  </main>
</template>

<script>
import "primeicons/primeicons.css";
import { SIGNUP_URL, VUE_APP_REDIRECT_URL, LOGIN_URL } from "../config";
import APIService from '../APIService';
import ActivityCard from '../components/feed/ActivityCard.vue';
import PostDetailsDialog from '../components/feed/PostDetailsDialog.vue';
import FeedService from '../FeedService';
import AccountNeededModal from '../components/feed/AccountNeededModal.vue';
import LoadingSpinner from '../components/LoadingSpinner.vue';
//import InFeedAdsense from 'vue-google-adsense/dist/InFeedAdsense.min.js';


export default {
  data() {
    return {
      annual:false,
      isLoggedIn: false,

      currentPlan: 1,
      feed: [],
      selectedPost: { activity: null, noteVersion: null },
      loading:true,
    };
  },

  components: {
    ActivityCard,
    PostDetailsDialog,
    LoadingSpinner,
    AccountNeededModal,
    //InFeedAdsense
  },

  mounted() {
    console.log("mounting feed page");
    if (this.$route.query.loggedIn) {
      this.isLoggedIn = true;
    }

    this.getPosts();
  },

  watch: {
    $route(to, from) {//eslint-disable-line
      if( to.name == "feed" || to.name == "fintrivia"){
        this.getPosts();
      }
    }
  },

  computed: {
    signupText() {
      if(this.isFinTrivia){
        return  this.$t('feed.fintriviaSignupText')
      }
      else {
        return  this.$t('feed.latestSignupText')
      }
    },

    heroContent() {
      if( this.isFinTrivia) {
        return this.$t('feed.fintriviaContent');
      }
      else {
        return  this.$t('feed.latestContent');
      }
    },

    isFinTrivia() {
      return this.$route.name == 'fintrivia';
    }
  },

  methods: {
    isFinTriviaSite() {
      return window.location.host.includes("fintrivia.com")
    },

     openAccountNeededModal() {
         
          this.$refs.accountNeededModal.open();
      },
        

     goToSignup() {
            window.location.href = SIGNUP_URL;
        },
      goToLogin() {
         window.location.href = LOGIN_URL;
      },

    getPosts() {
      this.loading = true;
      APIService.get('/feed/latest/public/posts'+(this.isFinTrivia ? "?qOnly=true" : "")).then(resp => {
        if( resp.data.status == "success") {
          this.feed = this.deNormalizeActivities(resp.data.activities);
          FeedService.startStatusImpressionDetector("FeedPage.getPosts");
        }
        this.loading = false;
      }).catch(err => {
        console.log("Error getting posts:",err);
        
        
        this.loading = false;
      });
    },

    getRandomModulus(min, max) {
      return Math.floor(Math.random() * (max - min + 1) ) + min
    },

    getNoteVersion(noteVersionUUID) {
      return APIService.get('/research/notes/public/versions?noteVersionUUID='+noteVersionUUID);
    },

     isNote(activity) {
        return activity?.has_note == 1;
    },


    viewDetails(activity) {
      
           
            if( !this.$refs.detailsDialog.displayPost ) {
             // Mention type notifications have the actual activity data (summary for notes or content for normal posts) in it's 'object' field
                const activityData = (activity.summary || activity.content || activity.title) ? activity : activity.object;

                if (this.isNote(activityData)) {
                    this.getNoteVersion(activityData.note_version_uuid).then((resp) => {
                        this.selectedPost = { activity: activityData, noteVersion: resp.data.noteVersion };

                        this.$refs.detailsDialog.displayPost = true;
                    });
                } else {
                    this.selectedPost = { activity: activityData, noteVersion: null };
                    this.$refs.detailsDialog.displayPost = true;
                }
            }
            
        
    },

    deNormalizeActivities(objActivities) {
        let activities = [];
        for (var i = 0; i < objActivities.length; ++i) {
            let activity = objActivities[i];
            let activityData = activity.extra;
            
            activityData['actor'] = activity.actor;
            activityData['time'] = activity.time;
            activityData['id'] = activity.id;
            activityData['verb'] = activity.verb;
            
            if(activity.object.data.verb != undefined) {
                activityData['object'] = activity.object.data;
            } else {
                activityData['object'] = activity.object;
            }

            activityData['foreign_id'] = activity.foreignID;
            activityData['target'] = activity.target;
            activityData['score'] = activity.score;
            activityData['reaction_counts'] = activity.reactionCounts;
            activityData['own_reactions'] = this.deNormalizeReactions(activity.ownReactions); //need to see why latest reactions and own reactions are equivalent
            activityData['latest_reactions'] = this.deNormalizeReactions(activity.latestReactions);
            activities.push(activityData);
        }
        return activities;
    },

    deNormalizeReactions(reactionObj){
        let reactions = {}
        if( reactionObj?.comment){
            let comments = []
            for( var i = 0; i < reactionObj.comment.length; ++i ) {
                let commentObj = reactionObj.comment[i];
                let comment = commentObj;
                
                comment["user"] = commentObj.userData;
                comment["data"] = commentObj.activityData;
               
                comments.push(comment);
                
            }
            reactions['comment'] = { 'comment': comments };
        }
        if( reactionObj?.like){
            let likes = []
            for( var j = 0; j < reactionObj.like.length; ++j ) {
                let likeObj = reactionObj.like[j];
                let like = likeObj;
                
                like["user"] = likeObj.userData;
                like["data"] = likeObj.activityData;
               
                likes.push(like);
                
            }
            reactions['like'] = { 'like': likes };
        }
        return reactionObj;
    },
    isMobile() {
      let check = false;

      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);//eslint-disable-line
    
      return check;
    },

    

    goToApp() {
      if (this.isLoggedIn) {
        if (this.$route.query.fromBilling) {
          window.close();
        } else {
          window.location = VUE_APP_REDIRECT_URL;
        }
      } else {
        window.location.href = SIGNUP_URL;
      }
    },

    
  },
};
</script>

<style scoped>
.googadd{
    height: 500px;
}
.adswrapper{
     
    border-radius: 16px;
    margin-bottom: 16px;
    box-shadow: 0px 1px 1px rgba(0, 0, 0, 0.14), 0px 2px 1px rgba(0, 0, 0, 0.12), 0px 1px 3px rgba(0, 0, 0, 0.2);

}

.hero-description {
  line-height: 1.6;
  margin-bottom: 2.4rem;
  max-width: 100rem;
  color: #333;
  text-align: center;
}

.container {
  padding-top: 10rem;
  max-width: 80rem;
}
.pricing-container {
  padding: 18rem 12rem;
}

.description {
  margin-bottom: 6.4rem;
  line-height: 3.5rem;
}

.toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: end;
  justify-self: start;
}

.toggle h4 {
  font-size: 1.8rem;
  font-weight: 400;
  margin-right: 0.8rem;
}

.toggle h4:last-child {
  margin-left: 0.8rem;
  margin-right: 0;
}

.pricing-grid,
.grid-header {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 2rem;
}

.grid-subheader,
.grid-header {
  grid-column: 1 / 5;
}

.plan {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;
}

.plan h3 {
  font-size: 2rem;
  font-weight: 400;
  margin-bottom: 1.2rem;
  text-align: center;
}

.pricing-grid .plan p {
  font-size: 2.4rem;
  font-weight: 400;
  margin-bottom: 1.2rem;
  color: #999;
}

.plan button {
  padding: 1.2rem 2.4rem;
  border-radius: 8px;
  border: 1px solid #693bf5;
  background-color: #fff;
  color: #333;
  cursor: pointer;
  font-size: 1.6rem;
  font-family: inherit;
}

.plan button:hover {
  background-color: #693bf5;
  color: #fff;
}

.grid-subheader {
  padding-top: 2.4rem;
  padding-bottom: 1.2rem;
  border-bottom: 1px solid #d1d2d3;
}

.grid-subheader h2 {
  font-size: 2.8rem;
  font-weight: 500;
  color: #333;
}

.pricing-grid p {
  font-size: 1.6rem;
  font-weight: 400;
  color: #333;
  margin-bottom: 1.2rem;
  align-self: center;
  line-height: 1.2;
}

.pi-check,
.pi-times {
  font-size: 2.4rem;
  color: #3c9;
  align-self: center;
  justify-self: center;
}

.pi-times {
  color: #d1d2d3;
}

.toggle {
  background-color: #d1d2d3;
  padding: 0.6rem;
  border-radius: 8px;
}

.toggle button {
  margin-right: 8px;
  padding: 1rem 2rem;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-family: inherit;
  background-color: transparent;
}

.toggle button:last-child {
  margin-right: 0;
}

.toggle button.selected {
  background-color: #f2f4fa;
}

.pricing-grid .free__direct-messaging {
  text-align: center;
  margin-bottom: 0px;
}

/* **************************** */
/* BELOW 1360px (Small desktop/laptop) */
/* **************************** */
@media (max-width: 85em) {
  .heading-primary {
    font-size: 6rem;
  }
}

/* **************************** */
/* BELOW 976px (landscape tablets) */
/* **************************** */
@media (max-width: 61em) {
  .heading-primary {
    font-size: 5.6rem;
  }
}

/* **************************** */
/* BELOW 800px (tablet) */
/* **************************** */
@media (max-width: 50em) {
  .pricing-container {
    padding-left: 6rem;
    padding-right: 6rem;
  }
}

/* **************************** */
/* BELOW 592px (mobile) */
/* **************************** */
@media (max-width: 37em) {
  .pricing-container {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
  }

  .heading-primary {
    font-size: 5rem;
  }

  .pricing-grid,
  .grid-header {
    grid-template-columns: 1fr;
  }

  .pricing-grid .free__direct-messaging {
    grid-column: auto;
    text-align: right;
    margin-bottom: 1.2rem;
  }

  .pi-check,
  .pi-times {
    text-align: right;
  }
}

/* **************************** */
/* BELOW 496px (mobile) */
/* **************************** */
@media (max-width: 31em) {
  .heading-primary {
    font-size: 4.4rem;
    text-align: center;
    line-height: 1.2;
  }

  .description {
    text-align: center;
  }

  .pricing-grid,
  .grid-header {
    grid-template-columns: 1fr;
    grid-gap: 0;
  }

  .toggle {
    grid-column: 1 / 3;
    justify-self: center;
    margin-bottom: 2.4rem;
  }

  .pricing-grid p {
    grid-column: 1 / 4;
    font-size: 1.8rem;
  }

  .grid-subheader {
    margin-top: 3.2rem;
    margin-bottom: 1.6rem;
  }

  .pi-check,
  .pi-times {
    width: 100%;
    justify-self: center;
    margin-bottom: 1.6rem;
  }

  .pi-check.last {
    border-bottom: none;
    padding-bottom: 0;
    margin-bottom: 0;
  }

  .pricing-grid .plan p {
    font-size: 2.2rem;
  }
}

/* **************************** */
/* BELOW 432px (mobile) */
/* **************************** */
@media (max-width: 27em) {
  .pricing-container {
    padding-left: 1rem;
    padding-right: 1rem;
  }
}
</style>
